import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { IBillingPayment } from '../../compiler/billing.interface';
import { formatBangkokDateTime } from '../../utilities/bangkokDateTime';

const BillingArchivedEvidence: React.FC<{
  files: NonNullable<IBillingPayment['archived_evidence']>;
  onPreview: (url: string, name: string) => void;
}> = ({ files, onPreview }) => files.length ? <Box>
  <Typography fontWeight={700}>หลักฐานก่อนแก้ไข ({files.length} ไฟล์)</Typography>
  <Typography variant="caption">เก็บไว้ตรวจย้อนหลัง ไม่นำมารวมยอดหลักฐานปัจจุบัน</Typography>
  {files.map((file, index) => <Stack key={`${file.uuid || file.file_uuid}-${index}`} direction="row" spacing={1} alignItems="center">
    <Typography fontSize={12}>{file.file_name} · เก็บโดย {file.archived_by || '-'} · {file.archived_at ? formatBangkokDateTime(file.archived_at) : '-'}</Typography>
    <Button size="small" disabled={!file.file_url} onClick={() => file.file_url && onPreview(file.file_url, file.file_name)}>ดูหลักฐานเดิม</Button>
  </Stack>)}
</Box> : null;
export default BillingArchivedEvidence;
